import { IField, IFieldMetaData } from "./IField"

export interface IFamilyGroupFormField {
  FamilyGroup: IFieldMetaData,
  BusinessUnit: IFieldMetaData,
  SuperCategory: IFieldMetaData,
  Category: IFieldMetaData,
  SubCategory: IFieldMetaData,
  Segment: IFieldMetaData,
  ProductCount: IFieldMetaData,
  CreatedDate: IFieldMetaData,
  UpdatedDate: IFieldMetaData,
  UpdatedBy: IFieldMetaData,
  FamilyGroupNew: IFieldMetaData,
  Company: IFieldMetaData,
  SuperCatDesc: IFieldMetaData,
  SubCategoryDesc: IFieldMetaData,
  CategoryDesc: IFieldMetaData,
  BusinessUnitDesc: IFieldMetaData,
  SegmentDesc: IFieldMetaData,
  ProductType: IFieldMetaData,
}

export const FIELDS: IFamilyGroupFormField = {
  FamilyGroup: { name: "familyGroup", rules: {} },
  BusinessUnit: { name: "businessUnit", rules: {required: {}} },
  SuperCategory: { name: "superCategory", rules: {required: {}} },
  Category: { name: "category", rules: {required: {}} },
  SubCategory: { name: "subCategory", rules: {required: {}} },
  Segment: { name: "segment", rules: {required: {}} },
  CreatedDate: { name: "createdDate", rules: {required: {}} },
  UpdatedDate: { name: "updatedDate", rules: {required: {}} },
  UpdatedBy: { name: "UpdatedBy", rules: {} },
  ProductCount: { name: "productCount", rules: {required: {}} },
  FamilyGroupNew: { name: "familyGroupNew", rules: {required: {}} },
  Company: { name: "Company", rules: {required: {}} },
  SuperCatDesc: { name: "SuperCatDesc", rules: {required: {}} },
  SubCategoryDesc: { name: "SubCategoryDesc", rules: {required: {}} },
  CategoryDesc: { name: "CategoryDesc", rules: {required: {}} },
  BusinessUnitDesc: { name: "BusinessUnitDesc", rules: {required: {}} },
  SegmentDesc: { name: "SegmentDesc", rules: {required: {}} },
  ProductType: { name: "ProductType", rules: {required: {}} }
}

export const ERROR_MESSAGES = {
  required: "This field is required",
  inputType: "This field only takes decimal values"
}

export enum FormInputLevels {
  FamilyGroup = "Family Group",
  BusinessUnit = "Business Unit",
  SuperCategory = "Super Category",
  category = "Category",
  subCategory = " Sub Category",
  segment = "Segment",
  productCount = "Item Count UOM",
  updatedBy = "Updated By",
  FamilyGroupNew = "familyGroupNew",
  Company = "Company",
  SuperCatDesc = "SuperCatDesc",
  SubCategoryDesc = "SubCategoryDesc",
  CategoryDesc = "CategoryDesc",
  BusinessUnitDesc = "BusinessUnitDesc",
  SegmentDesc = "SegmentDesc",
  ProductType = "Product Group",
  createdDate = "Created Date",
  updatedDate = "Updated Date",
}

export interface IFamilyGroupError {
  FamilyGroup: string | undefined,
  BusinessUnit: string | undefined,
  SuperCategory: string | undefined,
  Category: string | undefined,
  SubCategory: string | undefined,
  Segment: string | undefined,
  ProductCount: string | undefined,
  CreatedDate: string | undefined,
  UpdatedDate: string | undefined,
  UpdatedBy: string | undefined,
  FamilyGroupNew: string | undefined,
  Company: string | undefined,
  SuperCatDesc: string | undefined,
  SubCategoryDesc: string | undefined,
  CategoryDesc: string | undefined,
  BusinessUnitDesc: string | undefined,
  SegmentDesc: string | undefined,
  ProductType: string | undefined,
}

export const ProductTypeOptions = [
  { label: "AMB", value: "AMB" },
  { label: "FRZ", value: "FRZ" },
  { label: "PRD", value: "PRD" },
  { label: "CHL", value: "CHL" }
];